/**
 * Shared types and utilities for the billing claims table layout.
 *
 * Layout modes control which columns are visible at different screen widths:
 * - full     (xl, >= 1536px): All columns
 * - standard (lg, 1200-1535px): Drop Payer, Readiness
 * - compact  (md, 900-1199px): Date, Patient, Next Action, Amount, Status, Actions only
 * - card     (< 900px): Stacked card layout
 */

export type TableLayoutMode = 'full' | 'standard' | 'compact' | 'card';

export const GRID_GAP = 1.5;

/**
 * Returns the CSS Grid `gridTemplateColumns` value for a given layout mode.
 *
 * Column order by layout (matches encounters: Date, Provider, Patient):
 *   full:     Date(90) Provider(0.8fr) Patient(1fr) Payer(0.7fr) NextAction(1.2fr) Amount(90) Status(80) Issues(70) Actions(44)
 *   standard: Date(90) Provider(0.8fr) Patient(1fr) NextAction(1.2fr) Amount(90) Status(80) Issues(70) Actions(44)
 *   compact:  Date(90) Patient(1fr) NextAction(1.2fr) Amount(80) Status(80) Actions(44)
 *   card:     Not applicable (returns empty string)
 */
export function getGridTemplateColumns(layout: TableLayoutMode): string {
  switch (layout) {
    case 'full':
      return '90px 0.8fr 1fr 0.7fr 1.2fr 90px 80px 70px 44px';
    case 'standard':
      return '90px 0.8fr 1fr 1.2fr 90px 80px 70px 44px';
    case 'compact':
      return '90px 1fr 1.2fr 80px 80px 44px';
    case 'card':
      return '';
  }
}
